import {createContext} from 'react';

export const SIDEBAR_NAV_FLAG = 'sidebar-nav-v2';

const SidebarVariantContext = createContext('control');

export default SidebarVariantContext;
